(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/iam-idp/assets/javascripts/react/components/freja/freja-start.js') >= 0) return;  svs.modules.push('/modules/iam-idp/assets/javascripts/react/components/freja/freja-start.js');

'use strict';

const _svs$ui = svs.ui,
  Button = _svs$ui.Button,
  Bank = _svs$ui.ReactBank;
const postMessageToParent = svs.iam_idp.utils.postMessageToParent;
const PARENT_REDIRECT = svs.iam_idp.constants.POST_MESSAGE_TYPES.PARENT_REDIRECT;
const _svs$iam_idp$componen = svs.iam_idp.components.shared,
  Qr = _svs$iam_idp$componen.Qr,
  SelectorButtons = _svs$iam_idp$componen.SelectorButtons;
const isPnp = svs.iam_idp.data.isPnp;
const login = svs.iam_idp.utils.Login;
const _jotai = jotai,
  useAtomValue = _jotai.useAtomValue;
const activeMethodAtom = svs.iam_idp.atoms.activeMethodAtom;
const FrejaStart = _ref => {
  let showQR = _ref.showQR,
    isNewCustomer = _ref.isNewCustomer;
  const rawReturnUrl = svs.utils.url.queryString.returnUrl;
  const returnUrl = rawReturnUrl ? svs.utils.url.makeInternal(rawReturnUrl) : null;
  const activeMethod = useAtomValue(activeMethodAtom);
  const isFrejaDesktop = activeMethod.isFreja && !showQR;
  return React.createElement("div", null, React.createElement(SelectorButtons, null), showQR && React.createElement(Qr, {
    isNewCustomer: isNewCustomer,
    isPnp: isPnp
  }), React.createElement("div", {
    className: "login-buttons-container"
  }, isFrejaDesktop && React.createElement(Button, {
    block: true,
    className: "btn-green margin-top-1 margin-bottom-1",
    iconPosition: "left",
    inverted: isPnp,
    onClick: () => {
      login.start(isNewCustomer);
    },
    size: 300
  }, React.createElement(Bank, {
    height: 24,
    name: isPnp ? activeMethod.pnpIcon : activeMethod.icon
  }), isNewCustomer ? 'Bli kund' : 'Logga in'), React.createElement(Button, {
    block: true,
    className: "",
    inverted: isPnp,
    onClick: () => {
      postMessageToParent({
        value: returnUrl,
        type: PARENT_REDIRECT
      });
    },
    size: 300,
    transparent: true
  }, "Avbryt")));
};
svs.iam_idp.components.freja.FrejaStart = FrejaStart;

 })(window);